/**
 * qrz
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering */

export class SearchApi {
    protected basePath = 'https://localhost:44364';
    public defaultHeaders : any = {};

    static $inject: string[] = ['$http', '$httpParamSerializer', 'basePath'];

    constructor(protected $http: ng.IHttpService, protected $httpParamSerializer?: (d: any) => any, basePath?: string) {
        if (basePath !== undefined) {
            this.basePath = basePath;
        }
    }

    /**
     * 
     */
    public searchSearchShopAll (extraHttpRequestParams?: any ) : ng.IHttpPromise<Array<models.ShopCsvRow>> {
        const localVarPath = this.basePath + '/api/Search/SearchShopAll';

        let queryParameters: any = {};
        let headerParams: any = (<any>Object).assign({}, this.defaultHeaders);
        let httpRequestParams: ng.IRequestConfig = {
            method: 'POST',
            url: localVarPath,
            params: queryParameters,
            headers: headerParams
        };

        if (extraHttpRequestParams) {
            httpRequestParams = (<any>Object).assign(httpRequestParams, extraHttpRequestParams);
        }

        return this.$http(httpRequestParams);
    }
    /**
     * 
     * @param latE 
     * @param lngN 
     * @param latW 
     * @param lngS 
     */
    public searchSearchShopByNSEW (latE: number, lngN: number, latW: number, lngS: number, extraHttpRequestParams?: any ) : ng.IHttpPromise<Array<models.ShopCsvRow>> {
        const localVarPath = this.basePath + '/api/Search/SearchShopByNSEW';

        let queryParameters: any = {};
        let headerParams: any = (<any>Object).assign({}, this.defaultHeaders);
        // verify required parameter 'latE' is not null or undefined
        if (latE === null || latE === undefined) {
            throw new Error('Required parameter latE was null or undefined when calling searchSearchShopByNSEW.');
        }

        // verify required parameter 'lngN' is not null or undefined
        if (lngN === null || lngN === undefined) {
            throw new Error('Required parameter lngN was null or undefined when calling searchSearchShopByNSEW.');
        }

        // verify required parameter 'latW' is not null or undefined
        if (latW === null || latW === undefined) {
            throw new Error('Required parameter latW was null or undefined when calling searchSearchShopByNSEW.');
        }

        // verify required parameter 'lngS' is not null or undefined
        if (lngS === null || lngS === undefined) {
            throw new Error('Required parameter lngS was null or undefined when calling searchSearchShopByNSEW.');
        }

        if (latE !== undefined) {
            queryParameters['lat_e'] = latE;
        }

        if (lngN !== undefined) {
            queryParameters['lng_n'] = lngN;
        }

        if (latW !== undefined) {
            queryParameters['lat_w'] = latW;
        }

        if (lngS !== undefined) {
            queryParameters['lng_s'] = lngS;
        }

        let httpRequestParams: ng.IRequestConfig = {
            method: 'POST',
            url: localVarPath,
            params: queryParameters,
            headers: headerParams
        };

        if (extraHttpRequestParams) {
            httpRequestParams = (<any>Object).assign(httpRequestParams, extraHttpRequestParams);
        }

        return this.$http(httpRequestParams);
    }
    /**
     * 
     */
    public searchShops (extraHttpRequestParams?: any ) : ng.IHttpPromise<Array<models.ShopCsvRow>> {
        const localVarPath = this.basePath + '/api/Search/Shops';

        let queryParameters: any = {};
        let headerParams: any = (<any>Object).assign({}, this.defaultHeaders);
        let httpRequestParams: ng.IRequestConfig = {
            method: 'GET',
            url: localVarPath,
            params: queryParameters,
            headers: headerParams
        };

        if (extraHttpRequestParams) {
            httpRequestParams = (<any>Object).assign(httpRequestParams, extraHttpRequestParams);
        }

        return this.$http(httpRequestParams);
    }
    /**
     * 
     */
    public searchUnits (extraHttpRequestParams?: any ) : ng.IHttpPromise<Array<models.UnitCsvRow>> {
        const localVarPath = this.basePath + '/api/Search/Units';

        let queryParameters: any = {};
        let headerParams: any = (<any>Object).assign({}, this.defaultHeaders);
        let httpRequestParams: ng.IRequestConfig = {
            method: 'GET',
            url: localVarPath,
            params: queryParameters,
            headers: headerParams
        };

        if (extraHttpRequestParams) {
            httpRequestParams = (<any>Object).assign(httpRequestParams, extraHttpRequestParams);
        }

        return this.$http(httpRequestParams);
    }
}
